import { useTranslation } from "@refinedev/core";
import DateTimePicker from "components/datetimePicker";
import Input from "components/input";
import { Label } from "components/label";
import { IAdditionalSetupForm, ISimpleEventDetail } from "interfaces";
import { get } from "lodash";
import moment from "moment";
import { Controller, useFormContext } from "react-hook-form";

export const TransferTicket = ({
  isEdit,
}: {
  isEdit: boolean;
  eventDetailData: ISimpleEventDetail;
}) => {
  const { translate } = useTranslation();
  const {
    register,
    control,
    formState: { errors },
  } = useFormContext<IAdditionalSetupForm>(); // retrieve all hook methods

  return isEdit ? (
    <div className="box-container p-4 sm:p-6">
      <div className="grid gap-x-4 gap-y-6 sm:grid-cols-6 lg:gap-x-6">
        <div className="sm:col-span-3">
          <Label
            required
            id="transfer_ticket.start_transfer_ticket_date"
            name={translate(
              "eventSetup.additionalSetup.transferTicket.startDate"
            )}
          />
          <Controller
            control={control}
            name="transfer_ticket.start_transfer_ticket_date"
            render={({ field: { onChange, value = "" } }) => {
              return (
                <DateTimePicker
                  id="transfer_ticket.start_transfer_ticket_date"
                  placeholder={translate(
                    "eventSetup.additionalSetup.transferTicket.startDate"
                  )}
                  error={get(
                    errors,
                    `transfer_ticket.start_transfer_ticket_date.message`,
                    ""
                  )}
                  value={value}
                  onChange={(date: any) =>
                    date === null
                      ? onChange("")
                      : onChange(moment(date).format("YYYY-MM-DD HH:mm:ss"))
                  }
                />
              );
            }}
          />
          {get(errors, `transfer_ticket.start_transfer_ticket_date`, "") ? (
            <p className="error-text">
              <span className="font-medium">
                {get(
                  errors,
                  `transfer_ticket.start_transfer_ticket_date.message`,
                  ""
                )}
              </span>
            </p>
          ) : null}
        </div>
        <div className="sm:col-span-3">
          <Label
            required
            id="transfer_ticket.end_transfer_ticket_date"
            name={translate(
              "eventSetup.additionalSetup.transferTicket.endDate"
            )}
          />
          <Controller
            control={control}
            name="transfer_ticket.end_transfer_ticket_date"
            render={({ field: { onChange, value = "" } }) => {
              return (
                <DateTimePicker
                  id="transfer_ticket.end_transfer_ticket_date"
                  placeholder={translate(
                    "eventSetup.additionalSetup.transferTicket.endDate"
                  )}
                  error={get(
                    errors,
                    `transfer_ticket.end_transfer_ticket_date.message`,
                    ""
                  )}
                  value={value}
                  onChange={(date: any) =>
                    date === null
                      ? onChange("")
                      : onChange(moment(date).format("YYYY-MM-DD HH:mm:ss"))
                  }
                />
              );
            }}
          />
          {get(errors, `transfer_ticket.end_transfer_ticket_date`, "") ? (
            <p className="error-text">
              <span className="font-medium">
                {get(
                  errors,
                  `transfer_ticket.end_transfer_ticket_date.message`,
                  ""
                )}
              </span>
            </p>
          ) : null}
        </div>
        <div className="sm:col-span-3">
          <Label
            required
            id="transfer_ticket.max_number_of_times_to_transfer_ticket"
            name={translate(
              "eventSetup.additionalSetup.transferTicket.maxNumberOfTimes"
            )}
          />
          <Input
            id="transfer_ticket.max_number_of_times_to_transfer_ticket"
            type="number"
            placeholder={translate(
              "eventSetup.additionalSetup.transferTicket.maxNumberOfTimes"
            )}
            error={get(
              errors,
              "transfer_ticket.max_number_of_times_to_transfer_ticket"
            )}
            {...register(
              "transfer_ticket.max_number_of_times_to_transfer_ticket",
              {
                valueAsNumber: true,
              }
            )}
          />
          {get(
            errors,
            `transfer_ticket.max_number_of_times_to_transfer_ticket`,
            ""
          ) ? (
            <p className="error-text">
              <span className="font-medium">
                {get(
                  errors,
                  `transfer_ticket.max_number_of_times_to_transfer_ticket.message`,
                  ""
                )}
              </span>
            </p>
          ) : null}
        </div>
        <div className="sm:col-span-3">
          <Label
            required
            id="transfer_ticket.transfer_ticket_fee"
            name={translate(
              "eventSetup.additionalSetup.transferTicket.transferFee"
            )}
          />
          <Input
            id="transfer_ticket.transfer_ticket_fee"
            type="number"
            placeholder={translate(
              "eventSetup.additionalSetup.transferTicket.transferFee"
            )}
            error={get(errors, "transfer_ticket.transfer_ticket_fee")}
            {...register("transfer_ticket.transfer_ticket_fee", {
              valueAsNumber: true,
            })}
          />
          {get(errors, `transfer_ticket.transfer_ticket_fee`, "") ? (
            <p className="error-text">
              <span className="font-medium">
                {get(errors, `transfer_ticket.transfer_ticket_fee.message`, "")}
              </span>
            </p>
          ) : null}
        </div>
      </div>
    </div>
  ) : (
    <></>
  );
};
